// Minimal theme JS: mobile menu toggle + fancybox init for PDP gallery
(function(){
  var burger = document.getElementById('fpHamburger');
  var nav = document.querySelector('.fp-navbar');
  if (burger && nav){
    burger.addEventListener('click', function(){ nav.classList.toggle('fp-nav-open'); });
  }
  // Fancybox (loaded from fullper.cl) for product image zoom
  try { if (window.jQuery && jQuery.fn.fancybox){ jQuery('[data-fancybox="images"]').fancybox(); } } catch(e){}
  // PDP thumbnails swap main image
  document.querySelectorAll('.fp-thumbs a').forEach(function(a){
    a.addEventListener('mouseenter', function(){
      var main = document.querySelector('.miniGaleria img');
      var img = a.querySelector('img');
      if (main && img){ main.src = img.src.replace('width=90','width=700'); }
    });
  });
})();


// ---- Favoritos (localStorage, sin backend/app) 2026-08-13 ----
var FPFav = (function(){
  var KEY = 'fp_favoritos';
  function getAll(){
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; }
  }
  function has(handle){ return getAll().indexOf(handle) !== -1; }
  function toggle(handle){
    var list = getAll();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle); else list.splice(i, 1);
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('fp-fav-change', { detail: { list: list } }));
    return list.indexOf(handle) !== -1;
  }
  function count(){ return getAll().length; }
  return { getAll: getAll, has: has, toggle: toggle, count: count };
})();
window.FPFav = FPFav;

function fpFavUpdateBadge(){
  var badge = document.querySelector('[data-fp-fav-count]');
  if (badge) badge.textContent = FPFav.count();
}
function fpFavSetButtonState(btn){
  var handle = btn.getAttribute('data-fp-fav-handle');
  var active = FPFav.has(handle);
  btn.classList.toggle('is-fav', active);
  var label = btn.querySelector('[data-fp-fav-label]');
  if (label) label.textContent = active ? 'En tus favoritos' : 'Agregar a favoritos';
}
document.addEventListener('click', function(e){
  var btn = e.target.closest('[data-fp-fav-handle]');
  if (!btn) return;
  e.preventDefault();
  var handle = btn.getAttribute('data-fp-fav-handle');
  FPFav.toggle(handle);
  document.querySelectorAll('[data-fp-fav-handle="' + handle + '"]').forEach(fpFavSetButtonState);
  fpFavUpdateBadge();
});
document.querySelectorAll('[data-fp-fav-handle]').forEach(fpFavSetButtonState);
fpFavUpdateBadge();


// ---- Carruseles (Owl) para Marcas y Productos Destacados, 2026-08-13 ----
if (window.jQuery && jQuery.fn.owlCarousel) {
  jQuery('.fp-owl-marcas').owlCarousel({
    loop: true, margin: 14, nav: true, dots: false,
    autoplay: true, autoplayTimeout: 3000, autoplayHoverPause: true,
    responsive: { 0: { items: 3 }, 600: { items: 5 }, 1000: { items: 7 } }
  });
  jQuery('.fp-owl-destacados').owlCarousel({
    loop: false, margin: 16, nav: true, dots: false,
    responsive: { 0: { items: 1.3 }, 600: { items: 2.3 }, 900: { items: 3.3 }, 1200: { items: 4.3 } }
  });
}
